var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "scroll-view", attrs: { id: _vm.id } },
    [
      _vm._l(_vm.items, function(listItem, index) {
        return [
          _vm._t(
            "item-tpl",
            [_vm._v("\n            " + _vm._s(listItem) + "\n        ")],
            { listItem: listItem, index: index }
          )
        ]
      }),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.identifier, spinner: "waveDots" },
          on: { infinite: _vm.infiniteHandler }
        },
        [
          _vm._t("noData", [_vm._v("\n            No results\n        ")], {
            slot: "no-results"
          })
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }